import React from 'react';
import classNames from 'classnames';
import Tabs from '#components/Elements/Tabs/Tabs';
import styles from './TabHeader.scss';

export default function TabHeader({
  className,
  children,
  isStatic,
  insertOnRight,
}) {
  return (
    <div className={classNames(styles.headerContainer, className)}>
      <div className={classNames(styles.header, className)}>
        <Tabs className={styles.tabs} isStatic={isStatic}>
          {children}
        </Tabs>
        {!!insertOnRight && (
          <div className={styles.rightContent}>{insertOnRight}</div>
        )}
      </div>
      {!!insertOnRight && (
        <div className={styles.rightContentMobile}>{insertOnRight}</div>
      )}
    </div>
  );
}
